import { type Table } from '@tanstack/react-table';
import React from 'react';

const DEFAULT_PAGE_OPTIONS = [10, 20, 50, 100];

type ItemsPerPageSelectorProps<T> = {
  table: Table<T>;
  options?: number[];
  label?: string;
  pageItemCount?: number;
};

function ItemsPerPageSelector<T>({
  table,
  options = DEFAULT_PAGE_OPTIONS,
  label = 'Linhas por página:',
  pageItemCount,
}: ItemsPerPageSelectorProps<T>): React.ReactElement {
  const { pageIndex, pageSize } = table.getState().pagination;
  const total = table.getRowCount();
  const rowsOnPage = pageItemCount ?? table.getRowModel().rows.length;
  const start = total === 0 ? 0 : pageIndex * pageSize + 1;
  const end = pageIndex * pageSize + rowsOnPage;

  return (
    <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start ">
      <p className="mb-0 me-5 text-gray-600 d-none d-md-block">{label}</p>
      <div className="dropdown me-md-5">
        <button
          aria-expanded="false"
          aria-label={label}
          className="btn btn-secondary dropdown-toggle text-gray-600 py-2 px-4"
          data-bs-toggle="dropdown"
          type="button"
        >
          {pageSize}
        </button>
        <ul className="dropdown-menu">
          {options.map((option) => (
            <li key={option}>
              <a
                className="dropdown-item text-gray-600"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  table.setPageSize(option);
                }}
              >
                {option}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <span className="text-gray-600 text-nowrap d-none d-md-block">
        {start}–{end} de {total}
      </span>
    </div>
  );
}

export default ItemsPerPageSelector;
